import React, { useMemo } from "react";
import { MultiSelect } from "primereact/multiselect";
import { DEPUTATI } from "../../data/deputati";

const FOTO_BASE = "https://documenti.camera.it/_dati/costituente/costituenti/foto";

const selectedChipStyle = {
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    maxWidth: "100%",
    padding: "0.25rem 0.55rem",
    borderRadius: "16px",
    background: "#e5e7eb",
    color: "#334155",
    verticalAlign: "middle",
};

const selectedChipIconStyle = {
    cursor: "pointer",
    flexShrink: 0,
    fontSize: "0.85rem",
};

const selectedChipTextStyle = {
    minWidth: 0,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    lineHeight: 1.2,
};

const deputatoOptionStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    minWidth: 0,
    whiteSpace: "normal",
};

const deputatoOptionTextStyle = {
    minWidth: 0,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    lineHeight: 1.35,
};

const fotoUrl = (id) => {
    const numericId = parseInt(String(id ?? "").slice(2), 10);
    return Number.isNaN(numericId) ? null : `${FOTO_BASE}/d${numericId}.jpg`;
};

const Foto = ({ d, size = 42 }) => {
    const src = fotoUrl(d?.id);

    if (!src) return null;

    return (
        <img
            src={src}
            alt={`${d.cognome} ${d.nome}`}
            loading="lazy"
            width={size}
            height={size}
            style={{ borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
            onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
        />
    );
};

export default function FiltroDeputato({ value, onChange }) {
    const selectedDeputati = Array.isArray(value) ? value : [];

    const deputatiById = useMemo(
        () => new Map(DEPUTATI.map((d) => [d.id, d])),
        []
    );

    const removeSelected = (id, event) => {
        event.preventDefault();
        event.stopPropagation();
        onChange(selectedDeputati.filter((selectedId) => selectedId !== id));
    };

    const selectedItemTemplate = (id) => {
        const deputato = deputatiById.get(id);

        if (!deputato) return id;

        return (
            <span className="inline-flex align-items-center gap-2 mr-2" style={selectedChipStyle}>
                <Foto d={deputato} size={24} />
                <span style={selectedChipTextStyle}>{deputato.cognome} {deputato.nome}</span>
                <i
                    className="pi pi-times-circle"
                    role="button"
                    tabIndex={0}
                    aria-label={`Rimuovi ${deputato.cognome} ${deputato.nome}`}
                    style={selectedChipIconStyle}
                    onClick={(event) => removeSelected(id, event)}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            removeSelected(id, event);
                        }
                    }}
                />
            </span>
        );
    };

    return (
        <MultiSelect
            value={selectedDeputati}
            onChange={(e) => onChange(e.value ?? [])}
            filter
            showClear
            options={DEPUTATI}
            optionValue="id"
            optionLabel="cognome"
            filterBy="cognome,nome"
            display="chip"
            selectedItemTemplate={selectedItemTemplate}
            itemTemplate={(d) => (
                <div style={deputatoOptionStyle}>
                    <Foto d={d} />
                    <span style={deputatoOptionTextStyle}>
                        <span className="font-semibold">{d.cognome}</span> {d.nome}
                    </span>
                </div>
            )}
            maxSelectedLabels={3}
            pt={{
                item: {
                    className: 'pl-3 pt-1 pb-1',
                    style: { alignItems: "center", whiteSpace: "normal" },
                },
            }}
            placeholder="Seleziona uno o più deputati"
            className="w-full filter-chip-multiselect"
        />
    );
}
